import { render, staticRenderFns } from "./NoResultsPanel.vue?vue&type=template&id=66375c70&scoped=true&"
import script from "./NoResultsPanel.vue?vue&type=script&lang=js&"
export * from "./NoResultsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NoResultsPanel.vue?vue&type=style&index=0&id=66375c70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66375c70",
  null
  
)

export default component.exports